/* eslint-disable no-undef */
export const localStorage = window.localStorage;
export const location = window.location;
export const document = window.document;
export const history = window.history;
